import { useMutation } from "react-query";
import useApi from "utils/api/useApi";

export const useGetItemClassCarousel = () => {
  const api = useApi();
  const getItemClassCarousel = async (product_type_id: number) => {
    const res = await api
      .path("item_class/carousel/detail", {item_class_id: product_type_id})
      .get();
    return res?.data?.data
  };

  const { data, isLoading, error, mutate } = useMutation((product_type_id: number) => getItemClassCarousel(product_type_id));

  return {
    getItemClassCarouselData: data,
    getItemClassCarouselError: error,
    getItemClassCarouselLoading: isLoading,
    getItemClassCarouselMutate: mutate,
  };
};
